//
//
//
//
//
//
//
//
//

import Vue from 'vue'

export default Vue.extend({
  name: 'ParentField',
  props: {
    title: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: Number,
    },
  },
})
